import React from 'react';
import { Award } from 'lucide-react';

export const Brands = () => {
  return (
    <div className="min-h-screen pt-24 bg-white">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-3 bg-orange-500/20 px-6 py-3 rounded-full mb-6 border border-orange-500/30">
              <Award className="text-orange-400" size={28} />
              <span className="text-orange-400 font-semibold text-lg">Trusted by Industry Leaders</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">Brands That Trust Us</h1>
            <p className="text-xl text-slate-300 leading-relaxed">
              We don't just move freight — we keep your promises. Partnering with India's leading enterprises across diverse industries.
            </p>
          </div>
        </div>
      </section>

      {/* Logos Display Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            {/* High-Quality Logo Display */}
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-slate-100">
              <div className="p-4 md:p-8">
                <img 
                  src="/assets/brand-logos-hd.png"
                  alt="Trusted brands - Flyberry Gourmet, ecobliss, ANITA'S AROMATICS, DOT&KEY SKINCARE, Patil Rail Infrastructure, PRAGATI, ABHI EGGS, ITC Limited, Afflatus, ARUNODAYA PRINT PACK, Minimalist, SHRINATH ROTOPACK, instabites, VEDAS, TOPGRIP INDUSTRIES, SONA SIGNATURE PAPERS, KALA JYOTHI"
                  className="w-full h-auto"
                  style={{ 
                    imageRendering: '-webkit-optimize-contrast',
                    imageRendering: 'crisp-edges'
                  }}
                  loading="eager"
                />
              </div>
            </div>

            {/* Trust Stats */}
            <div className="mt-16 grid md:grid-cols-4 gap-8 text-center">
              <div className="p-6">
                <div className="text-5xl font-bold text-orange-500 mb-3">17+</div>
                <p className="text-slate-600 font-medium text-lg">Trusted Brands</p>
              </div>
              <div className="p-6">
                <div className="text-5xl font-bold text-cyan-500 mb-3">500+</div>
                <p className="text-slate-600 font-medium text-lg">Total Clients</p>
              </div>
              <div className="p-6">
                <div className="text-5xl font-bold text-green-500 mb-3">98%</div>
                <p className="text-slate-600 font-medium text-lg">Client Retention</p>
              </div>
              <div className="p-6">
                <div className="text-5xl font-bold text-purple-500 mb-3">15+</div>
                <p className="text-slate-600 font-medium text-lg">Years of Excellence</p>
              </div>
            </div>

            {/* Industries Served */}
            <div className="mt-20">
              <h2 className="text-3xl font-bold text-center text-slate-900 mb-12">Industries We Serve</h2>
              <div className="grid md:grid-cols-4 gap-6">
                <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-6 rounded-xl text-center hover:shadow-lg transition-shadow">
                  <p className="font-semibold text-slate-900">FMCG & Food</p>
                </div>
                <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 p-6 rounded-xl text-center hover:shadow-lg transition-shadow">
                  <p className="font-semibold text-slate-900">Skincare & Beauty</p>
                </div>
                <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl text-center hover:shadow-lg transition-shadow">
                  <p className="font-semibold text-slate-900">Packaging Solutions</p>
                </div>
                <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-xl text-center hover:shadow-lg transition-shadow">
                  <p className="font-semibold text-slate-900">Manufacturing</p>
                </div>
                <div className="bg-gradient-to-br from-pink-50 to-pink-100 p-6 rounded-xl text-center hover:shadow-lg transition-shadow">
                  <p className="font-semibold text-slate-900">Rail Infrastructure</p>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl text-center hover:shadow-lg transition-shadow">
                  <p className="font-semibold text-slate-900">Printing & Publishing</p>
                </div>
                <div className="bg-gradient-to-br from-amber-50 to-amber-100 p-6 rounded-xl text-center hover:shadow-lg transition-shadow">
                  <p className="font-semibold text-slate-900">Home Care Products</p>
                </div>
                <div className="bg-gradient-to-br from-teal-50 to-teal-100 p-6 rounded-xl text-center hover:shadow-lg transition-shadow">
                  <p className="font-semibold text-slate-900">Industrial Products</p>
                </div>
              </div>
            </div>

            {/* CTA Section */}
            <div className="mt-20 text-center bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl p-12 text-white">
              <h2 className="text-3xl md:text-4xl font-bold mb-4">
                Join Our Growing Family of Trusted Partners
              </h2>
              <p className="text-xl text-orange-50 mb-8 max-w-2xl mx-auto">
                Experience the Blue Bird difference. Let us handle your logistics while you focus on growing your business.
              </p>
              <a href="/contact">
                <button className="bg-white text-orange-600 hover:bg-slate-100 px-10 py-4 rounded-lg font-bold text-lg transition-colors shadow-xl">
                  Get Started Today
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
